export default {
  SET_USER (state, payload) {
    state.user = payload
  },
  SET_MANAGERS (state, payload) {
    state.managers = payload
  },
  SET_ERROR (state, payload) {
    state.error = payload
  },
  SET_ALLOW_B (state, payload) {
    state.allowB = payload
  },
  SET_ALLOW_BB (state, payload) {
    state.allowBB = payload
  },
  SET_SHOW_BALANCE (state, payload) {
    state.showBalance = payload
  },
  SET_TIP_DOSTAVKI (state, payload) {
    state.tipDostavki = payload || 0
  },
  SET_SVERKA_MESSAGE (state, payload) {
    state.showSverkaMessage = payload
  }
}
